var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/master-shop-hold-on-place-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-33f000e9!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/master-shop-hold-on-place-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MasterShopHoldOnPlaceList.vue
// module id = 657
// module chunks = 1